export default __webpack_public_path__ + "static/media/bg_1.ae2dd962.png";